import styled from '@emotion/styled';

import { isEmpty } from 'lodash';

import COLOR from '../../../../../../shared/constant/colorset';

import { ContentType, DealProduct, GroupProduct } from '../../../../types';

import SingleDeal from './SingleDeal';
import MultiDeal from './multi-deal/MultiDeal';
import OptionContent from './option-content/OptionContent';
import CalendarContent from './calendar-content/CalendarContent';

import DeliveryDelayNotice from './DeliveryDelayNotice';

import useDeliveryDelayNotice from '../../../../hooks/useDeliveryDelayNotice';

const Container = styled.div`
  border-bottom: 1px solid ${COLOR.bg};
`;

interface Props {
  productNo: number;
  isSoldOut: boolean;
  isPurchaseStatus: boolean;
  dealProducts: DealProduct[];
  contentType: ContentType;
  groupProduct: GroupProduct;
}

export default function OptionSection({
  productNo,
  isSoldOut,
  isPurchaseStatus,
  dealProducts,
  contentType,
  groupProduct,
}: Props) {
  const currentDealProduct = dealProducts[0];

  const {
    deliveryDelayNotice,
  } = useDeliveryDelayNotice();

  if (isEmpty(dealProducts)) {
    return null;
  }

  return (
    <Container>
      {contentType === 'SINGLE' && (
        <SingleDeal
          dealProduct={currentDealProduct}
          isPurchaseStatus={isPurchaseStatus}
          isSoldOut={isSoldOut}
        />
      )}
      {contentType === 'MULTI' && (
        <MultiDeal dealProducts={dealProducts} />
      )}
      {contentType === 'OPTION' && (
        <OptionContent
          productNo={productNo}
          groupKeys={groupProduct.groupKeys}
          groupMembers={groupProduct.groupMembers}
          dealProduct={currentDealProduct}
        />
      )}
      {contentType === 'CALENDAR' && (
        <CalendarContent
          productNo={productNo}
          groupKeys={groupProduct.groupKeys}
          groupMembers={groupProduct.groupMembers}
          dealProduct={currentDealProduct}
        />
      )}
      {deliveryDelayNotice && (
        <DeliveryDelayNotice description={deliveryDelayNotice} />
      )}
    </Container>
  );
}
